import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _LineLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("rect", { width: 4, height: 4, x: 6, y: 13, stroke: "currentColor", rx: 2, transform: "rotate(90 6 13)" }),
            React.createElement("rect", { width: 4, height: 4, x: 17, y: 12, stroke: "currentColor", rx: 2, transform: "rotate(-90 17 12)" }),
            React.createElement("path", { stroke: "currentColor", d: "m18 11-1.5 1.5c-1.017 1.017-1.526 1.526-2.137 1.638-.24.045-.486.045-.726 0-.611-.112-1.12-.62-2.137-1.638s-1.526-1.526-2.137-1.638a2 2 0 0 0-.726 0c-.611.112-1.12.62-2.137 1.638L5 14" })));
}
const LineLight = forwardRef(_LineLight);
export { LineLight };
